export default {
  init() {
    /*
    * SELECTORS
    */
    let videoBtn = document.querySelector('.video-thumb .play-d');
    let videoBtnMobile = document.querySelector('.video-thumb .play-m');
    let videoSection = document.querySelector('.video-thumb');
    let videoIframe = document.querySelector('.video-thumb #corporate_video');
    /*
    * EVENTS
    */
    const handlePlayVIdeo = () => {
      let videoLink = videoBtn.getAttribute('data-video')
      videoSection.classList.add('play-video')
      videoIframe.setAttribute('src',videoLink)
    }
    const handlePlayVideoMobile = () => {
      let videoLink = videoBtnMobile.getAttribute('data-video')
      videoSection.classList.add('play-video')
      videoIframe.setAttribute('src',videoLink)
    }

    /*
    * ACTIONS
    */
    videoBtn.addEventListener('click', handlePlayVIdeo)
    videoBtnMobile.addEventListener('click', handlePlayVideoMobile)
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/aboutUs.js